<template>
    <div class="user-list">
        <status-tabs
            :status.sync="status"
            :statusList="statusList"
            :funcName="funcName"
        ></status-tabs>

        <search-tool
            ref="searchTool"
            :status="status"
            :statusList="statusList"
            :funcName="funcName"
            :searchForm="searchForm"
            :searchList="searchList"
            :searchForm_transfer="searchForm_transfer"
            :advanceSearchFields="advanceSearchFields"
            listName="transactionDetails"
            :loading="loading"
            :menuAuth="menuAuth"
            :inputPlaceholder="inputPlaceholder"
            :selected="selectList.length"
        ></search-tool>

        <div class="table" :style="{ height: height }">
            <el-table
                :data="tableData"
                ref="tableData"
                height="100%"
                row-key="id"
                @selection-change="handleSelectionChange"
                align="left"
            >
                <el-table-column
                    fixed
                    type="selection"
                    align="center"
                ></el-table-column>
                <el-table-column
                    fixed
                    label="ID"
                    prop="id"
                    width="80"
                >
                </el-table-column>
                <el-table-column
                    fixed
                    label="Name"
                    prop="username"
                    show-overflow-tooltip
                    width="180"
                >
                </el-table-column>
                <el-table-column
                    fixed
                    label="Email"
                    prop="email"
                    show-overflow-tooltip
                    width="200"
                >
                </el-table-column>
                <el-table-column label="Mobile" prop="mobile" width="120">
                </el-table-column>
                <el-table-column label="Source" prop="source" show-overflow-tooltip>
                </el-table-column>
                <el-table-column label="LoginNum" prop="login_count">
                </el-table-column>

                <el-table-column
                    label="Company"
                    prop="corp_entity.name"
                    show-overflow-tooltip
                    width="200"
                >
                </el-table-column>
                <el-table-column
                    label="Level"
                    prop="corp_entity.rank"
                >
                    <template slot-scope="scope">
                        <div>Lv.{{ scope.row.corp_entity.rank }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="Role" prop="role_name">
                </el-table-column>
                <el-table-column label="Balance" prop="corp_entity.balance">
                    <template slot-scope="scope">
                        <div>
                            {{
                                scope.row.corp_entity.currency &&
                                scope.row.corp_entity.currency.symbol
                            }}{{ scope.row.corp_entity.balance }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Business Code"
                    prop="corp_entity.business_code"
                    width="120"
                >
                    <template slot-scope="scope">
                        <div>
                            {{
                                scope.row.corp_entity.business_code &&
                                scope.row.corp_entity.business_code.code
                            }}
                            <span v-if="scope.row.corp_entity.business_code"
                                >({{
                                    scope.row.corp_entity.business_code
                                        .business
                                }})</span
                            >
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="Delivery Tag" prop="need_tag" width="120">
                </el-table-column>
                <el-table-column label="Status" width="140">
                    <template slot-scope="scope">
                        <span
                            class="general-table-tag"
                            :class="[
                                scope.row.status.value == 'Valid'
                                    ? 'primary'
                                    : scope.row.status.value == 'Invalid'
                                    ? 'info'
                                    : 'danger',
                            ]"
                        >
                            <i class="el-icon-s-help"></i>
                            {{ scope.row.status.value }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Activate Time"
                    prop="activate_time"
                    width="140"
                >
                </el-table-column>
                <el-table-column
                    label="Created On"
                    prop="created_at"
                    width="140"
                >
                </el-table-column>
                <el-table-column
                    label="Operation"
                    width="150"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <!-- <operation :scope="scope" @rowDo="rowDo"></operation> -->
                        <div style="display: flex">
                            <template v-for="item in scope.row.authority">
                                <el-button
                                    type="text"
                                    :class="item.class"
                                    size="mini"
                                    :key="item.id"
                                    v-if="
                                        item.status_flag !== 4 &&
                                        item.name != 'Store'
                                    "
                                    @click="rowDo(item, scope.row)"
                                    >{{ item.name }}</el-button
                                >
                                <stores
                                    :tableItem="scope.row"
                                    :platformList="platformList"
                                    v-else-if="item.name == 'Store'"
                                    :key="`${item.id}-stores`"
                                    style="margin-left: 8px"
                                >
                                    <el-button
                                        type="text"
                                        :class="item.class"
                                        size="mini"
                                        @click="rowDo(item, scope.row)"
                                        >{{ item.name }}</el-button
                                    >
                                </stores>
                                <delPopConfirm
                                    v-else
                                    :key="`${item.id}-del`"
                                    :btnClassName="'tableBtnShape'"
                                    style="margin-left: 8px"
                                    :item="{
                                        ...item,
                                        rowId: scope.row.id,
                                        type: 'text',
                                    }"
                                    @rowDo="rowDo"
                                ></delPopConfirm>
                            </template>
                        </div>
                    </template>
                </el-table-column>
                <el-empty :image-size="120" slot="empty">
                    <img slot="image" src="@/assets/image/empty-data.svg" />
                </el-empty>
            </el-table>
        </div>
        <pagination
            :paginationData="paginationData"
            @paginationChange="paginationChange"
            :funcName="funcName"
        ></pagination>
        <edit
            :editVisible.sync="editVisible"
            :tableItem="tableItem"
            :funcName="funcName"
        ></edit>
        <mystore
            :mystoreVisible.sync="mystoreVisible"
            :tableItem="tableItem"
            :platformList="platformList"
            :funcName="funcName"
        ></mystore>
        <batchChange
            :batchChangeVisible.sync="batchChangeVisible"
            :emailList.sync="emailList"
            :funcName="funcName"
        ></batchChange>
        <el-dialog
            :visible.sync="detailVisible"
            @closed="closeDialog"
            width="1220px"
            title="User Detail"
            append-to-body
        >
            <homeVue :userid="userid"></homeVue>
        </el-dialog>
        <!-- <homeVue :detailVisible.sync="detailVisible" :userid="userid"></homeVue> -->
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import { tableMixins } from "@/utils/tableMixins.js";
// import stores from "@/common/components/stores.vue";
import edit from "./userList/edit.vue";
import mystore from "./userList/mystore.vue";
import homeVue from "../home.vue";
import batchChange from "./userList/batchChange.vue";
export default {
    provide() {
        return {
            saleUserList: this.saleUserList,
        };
    },
    mixins: [infoTagsMixins, tableMixins],
    data() {
        return {
            inputPlaceholder: "Keywords include Name、Email、Mobile、Company、BusinessCode",
            searchForm: {
                activate_time: "",
            },
            searchForm_transfer: {
                activate_time: "",
            },
            funcName: "saleUserList",
            editVisible: false,
            mystoreVisible: false,
            batchChangeVisible: false,
            selectList: [],
            emailList:[],
            platformList: [],
            advanceSearchFields: {
                status: {
                    label: "Status",
                    type: "select",
                    options: [],
                },
                activate_time: {
                    label: "Activate Time",
                    type: "cascader",
                },
            },
            detailVisible: false,
            userid: 0
        };
    },
    methods: {
        // 获取用户主体列表
        saleUserList(page) {
            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            cmofferApi
                .saleUserList(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                        status: this.status,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.statusList = res.ext.tabs;
                        this.menuAuth = res.ext.op_auth;
                        this.advanceSearchFields.status.options =
                            res.ext.tabs.map((item) => {
                                return { label: item.name, value: item.status };
                            });
                        this.closeDrawer();
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 关闭drawer
        closeDrawer() {
            this.$refs.searchTool.$refs.drawer.closeDrawer();
        },
        batchChange(){
            this.batchChangeVisible = true;
        },
        /**
         * table内权限按钮
         */
        rowDo(item, row) {
            if (item.status_flag == 1) {
                this.tableItem = row;
                if (item.funcName == "edit") {
                    this.editVisible = true;
                } else if (item.funcName == "detail") {
                    this.userid = row.id;
                    this.detailVisible = true;
                } else if (item.funcName == "store") {
                    this.mystoreVisible = true;
                }
                
            } else if (item.status_flag == 2) {
                this.$prompt(`Do you want to continue?`, "Tip", {
                    inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
                    inputErrorMessage: `Please enter ${item.name}Reason`,
                    inputPlaceholder: `${item.name}Reason`,
                })
                    .then(({ value }) => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                                reason: value,
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 3) {
                this.$confirm(`Do you want to continue?`, "Tip", {
                    type: "warning",
                })
                    .then(() => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 4) {
                if (item.funcName == "delete") {
                    cmofferApi[item.parent_funcname](
                        {},
                        "delete",
                        item.rowId
                    ).then((res) => {
                        if (res) {
                            this.$message.success(`${item.name} Success`);
                            this[item.parent_funcname]();
                        }
                    });
                }
            }
        },
        /**
         清空高级搜索
        */
        clean() {
            this.searchForm = {};
            this.searchForm_transfer = {};
        },
        handleSelectionChange(val) {
            this.selectList = [];
            this.emailList = [];
            for (let i in val) {
                this.selectList.push(val[i].id);
                if(this.emailList.indexOf(val[i].email) == -1){
                    this.emailList.push(val[i].email);
                }
            } 
        },
        searchTags(params) {
            this.searchForm[params.key] = params.value;
        },
        closeTagsItem(key) {
            this.searchForm[key] = "";
        },
        closeTagsAll() {
            this.clean();
        },
        platform() {
            cmofferApi
                .platform(
                    {
                        menu_id: this.menu_id,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.platformList = res.data;
                    }
                });
        },
        async initialize() {
            await this.saleUserList();
            await this.platform();
        },
    },
    activated() {
        this.initialize();
    },
    components: {
        edit,
        // stores,
        mystore,
        homeVue,
        batchChange,
    },
    computed: {
        searchList() {
            return [
                {
                    label: this.$i18n.locale == "zh" ? "关键字" : "Keyword",
                    key: "keyword",
                    type: "input",
                },
                {
                    label: this.$i18n.locale == "zh" ? "授权" : "Activate Time",
                    key: "activate_time",
                    type: "cascader",
                },
            ];
        },
    },
    watch: {
        searchForm: {
            handler(newValue) {
                for (let k in newValue) {
                    let v = newValue[k];
                    if (!!v) {
                        this.hasSearchCondition = true;
                        return;
                    }
                }

                this.hasSearchCondition = false;
            },
            deep: true,
            immediate: true,
        },
        detailVisible:{
            handler(newValue) {
                if(newValue == false){
                    this.userid = 0;
                } 
            },
            deep: true,
            immediate: true,
        }
    },
};
</script>
<style lang="scss">
.user-list {
    width: 100%;
    height: 100%;
    background: #fff;
    .table {
        margin: 0 15px !important;
        padding: 0 !important;
        width: auto !important;

        height: calc(100% - 120px);
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        &.has-search-condition {
            height: calc(100% - 192px);
        }
    }
}
</style>
